module.exports = __webpack_public_path__ + "static/media/search_other.e63ec818.png";